module.exports = __webpack_public_path__ + "488ff220cfdc7c4dcf8082d8de623811.jpg";